export function generateAdminBranch()
{
    return({
        type:"GENERATE_ADMIN_CODE"
    })
}